import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Tag from '../../NewWorkInstruction/Tag'
class Tags extends Component {
    render() {
        let suggestedTags = Object.values(this.props.tags)
        let allTags = this.props.allTags ? this.props.allTags.map(tag => tag.name.toLowerCase()): []
        if (this.props.query) {
            suggestedTags = suggestedTags.filter(tag => tag.name.toLowerCase().includes(this.props.query))
        }

        if (allTags.length > 0) {
            suggestedTags = suggestedTags.filter(tag => !allTags.includes(tag.name.toLowerCase()))
        }

        return (
            <ul id="existing-tags-dropdown-bubble" className={`flex overflow-y ${this.props.visible ? "" : "hidden"}`}>
                {suggestedTags.length > 0 ? suggestedTags.map(tag => {
                        return <Tag key={`edit-tag-suggestion tagId-${tag._id}`}
                            label={tag.name}
                            isAttached={false}
                            onClick={(e) => this.props.selectTag(e, tag)}
                        />
                }) : <div>No Tags Found</div> }
            </ul>
        )
    }
}
export default withRouter(Tags)